import React, { useState } from "react";
import { Container, Row, Col, Card, Image } from "react-bootstrap";
import Particle from "../Particle";
import YoutubeEmbed from "../YoutubeEmbed";

import thumb001 from "../../Assets/Projects/thumb001.png";
import thumb002 from "../../Assets/Projects/thumb002.png";
import thumb003 from "../../Assets/Projects/thumb003.png";
import thumb004 from "../../Assets/Projects/thumb004.png";

function Projects() {
  const [embedId, setEmbedId] = useState("2G48aPsz66I");

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Our <strong className="purple">Portfolio </strong> Gallery
        </h1>
        <p style={{ color: "#979797" }}>
          Here are a few contents We've made recently.
        </p>

        <div>
          <YoutubeEmbed embedId={embedId} />
        </div>

        <Row style={{ justifyContent: "center", paddingBottom: "50px", paddingTop: "50px" }}>
          <Col md={4} className="project-card" onClick={() => { setEmbedId("2G48aPsz66I"); window.scrollTo(0, 0) }}>
            <Card className="project-card-view">
              <Image src={thumb004} alt="card-img" fluid />
            </Card>
          </Col>

          <Col md={4} className="project-card" onClick={() => { setEmbedId("Is8HJoXSVRg"); window.scrollTo(0, 0) }}>
            <Card className="project-card-view">
              <Image src={thumb003} alt="card-img" fluid />
            </Card>
          </Col>

          <Col md={4} className="project-card" onClick={() => { setEmbedId("hGUU0pmJqjs"); window.scrollTo(0, 0) }}>
            <Card className="project-card-view">
              <Image src={thumb002} alt="card-img" fluid />
            </Card>
          </Col>

          <Col md={4} className="project-card" onClick={() => { setEmbedId("-trmi-qq0mc"); window.scrollTo(0, 0) }} >
            <Card className="project-card-view">
              <Image src={thumb001} alt="card-img" fluid />
            </Card>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
